export default __webpack_public_path__ + "66610c5920a62c9a32b4e04bb60fc925.woff2";